module.exports = __webpack_public_path__ + "static/media/18ECA47.31683a91.jpg";